import * as React from 'react';
import { clsx } from 'clsx';

import styles from './HowItWorksItemFlight.css';

import { Step } from './Step';

interface IHowItWorksItemFlightProps {
  step: string;
  title: string;
  description?: string;
  isLtr: boolean;
}

export const HowItWorksItemFlight: React.FC<IHowItWorksItemFlightProps> = ({ step, title, description, isLtr }) => {
  return (
    <div className={clsx(styles['item'], isLtr && styles['item-ltr'])}>
      <div className={styles['content']}>
        <Step theme="primary" step={step} />
        <div className={styles['title']}>{title}</div>
        {description && <div className={styles['description']}>{description}</div>}
      </div>
      <div className={clsx(styles['image'], styles[`image-step-${step}`])} aria-label={title}></div>
    </div>
  );
};
